module.exports = __webpack_public_path__ + "media/svg/fo-27f92db9.svg";